import isPropValid from '@emotion/is-prop-valid'
import { PaddingType } from 'common/types/styleTypes'
import {
  mobilePaddingsCss,
  mobileTextCss,
  paddingsCss,
  TextProps,
  textCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface WebsiteLanguageSwitcherCurrentLangUiStylesInterface
  extends TextProps {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}
export const WebsiteLanguageSwitcherCurrentLangUi = styled.div.withConfig({
  shouldForwardProp: isPropValid,
})<WebsiteLanguageSwitcherCurrentLangUiStylesInterface>`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  gap: 6px;
  ${textCss};
  ${paddingsCss}
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
      ${mobileTextCss}
    `} 
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
    ${mobileTextCss}
  }
`
